export const createWalks_en = {
  'create' : 'Create',
  'create_start' : 'Start',
  'create_length' : 'Length',
  'title' : 'Title',
  'walk' : 'Walk',
  'description' : 'Description',
  'position' : 'Meeting place',
  'choose_position' : 'Choose position',
  'private_question' : 'Private?',
  'category' : 'Category',
  'category_distance' : 'Distance',
  'category_meeting' : 'Meeting',
  'category_morning': 'Morning walk',
  'category_lunch' : 'Lunch meeting',
  'category_fika' : 'Fika meeting',
  'category_problem' : 'Problemsolving',
  'category_50' : '50/50 walk',
  'category_series' : 'Walk series',
  'category_one' : '1:1',
  'repeat_walk' : 'Repeat walk',
  'each' : 'Each',
  'number_of' : 'Repetition',
  'every_month' : 'month (every 4th week)',
  'private_information_header' : 'Info privat walk',
  'private_information_message' : 'A private walk is only visible in your profile or to the person you share the link with.',
  'createWalk_error_message' : 'Please check your walks information',
  'teams_information_header' : 'Info team-walk',
  'teams_information_message' : 'A team-walk is only visible for registered members of your team',
  'repeat_information_header' : 'Info walk series',
  'repeat_information_message' : 'A walk series repeats by number and range. It is beneficial to use when planning or when you repeat a walk often.',
  'mark_place' : 'Select meeting place',
  'move_marker' : 'Move the map until the marker is placed where the walk starts.',
  'position_description' : 'Describe the place',
  'place' : 'Place',

  'city' : 'City/Place',
  'city_not_found' : 'Could not find the city/place',
  'city_not_found_tip' : 'Tip: If the city is not correct or could not be found you can enter it manually',
  'walks_created' : 'Walks that are created:',
  'create_walk' : 'Create',
  'save_walk' : 'Save walk',
  'delete_walk' : 'Remove walk',

  'created' : 'created',
  'copy_walk' : 'Copy walk',
  'change_walk' : 'Edit walk',
  'changed' : 'changed',
  'gps_error_map' : 'Du verkar ha stängt av gps-position. Googla "enable geolocation" för din browser om du vill slå på den. Du får börja på söder...',
  'available_to' :'Available to',
  'your_walk_has' : 'Your walk is now ',
  'bookable_until' : 'It will be bookable up until',
  'go_to_walk' : 'Go to the walk',
  'add_to_cal_question' : 'Add to your calendar?',
  'added_to_cal' : 'Added to the calendar',
  'remove_walk_confirmation' : 'Are you sure you want to remove the walk?',
  'choose_team' : 'Choose team',

  'walk_length' : 'The walk length'
}